<template>
  <lazy-div :load="doFetch">
    <v-card>
      <v-toolbar dense color="grey lighten-3" flat>
        <v-icon v-if="tranMode === 'New'">mdi-plus</v-icon>
        <v-icon v-if="tranMode === 'Review'">mdi-pencil</v-icon>
        <v-icon v-if="tranMode === 'Query'">mdi-magnify</v-icon>
        <v-toolbar-title v-if="tranMode === 'New'">New Default Text</v-toolbar-title>
        <v-toolbar-title v-if="tranMode === 'Review'">Edit Default Text</v-toolbar-title>
        <v-toolbar-title v-if="tranMode === 'Query'">View Defaults Text</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn v-if="tranMode !== 'New' && defTextPolType" color="primary" @click="$router.push('polTypeDefTxt')">
          Permitted Policy Type
          <v-icon right>mdi-view-list</v-icon>
        </v-btn>
        <v-btn v-if="tranMode !== 'New' && defTextBusCls" color="primary" @click="$router.push('busClsDefTxt')">
          Permitted Business Class
          <v-icon right>mdi-view-list</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <message :messages="messages"></message>
        <v-container fluid grid-list-sm>
          <v-layout row wrap>
            <v-flex xs6 v-if="tranMode === 'New'">
              <v-autocomplete
                :items="scrRefList"
                item-text="label"
                item-value="value"
                v-model="defTxtForm.scrRef"
                :label="labels.scrRef"
                :error-messages="errors.collect('scrRef')"
                data-vv-name="scrRef"
                :data-vv-as="labels.scrRef"
                v-validate="'required'"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs6 v-else>
              <v-subheader class="queryLabel">{{ labels.scrRef }}</v-subheader>
              <div class="queryValue">{{ defTxtForm.scrRefDesc }}</div>
            </v-flex>
            <v-flex xs6 v-if="tranMode === 'New'">
              <v-text-field
                v-model="defTxtForm.txtRef"
                :label="labels.txtRef"
                :error-messages="errors.collect('txtRef')"
                data-vv-name="txtRef"
                :data-vv-as="labels.txtRef"
                v-validate="'required|max:20'"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 v-else>
              <v-subheader class="queryLabel">{{ labels.txtRef }}</v-subheader>
              <div class="queryValue">{{ defTxtForm.txtRef }}</div>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs6 v-if="tranMode !== 'Query'">
              <v-text-field
                v-model="defTxtForm.txtTitle"
                :label="labels.txtTitle"
                :error-messages="errors.collect('txtTitle')"
                data-vv-name="txtTitle"
                :data-vv-as="labels.txtTitle"
                v-validate="'required|entry|max:60'"
              ></v-text-field>
            </v-flex>
            <v-flex v-else>
              <v-subheader class="queryLabel">{{ labels.txtTitle }}</v-subheader>
              <div class="queryValue">{{ defTxtForm.txtTitle }}</div>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex v-if="tranMode !== 'Query'">
              <v-textarea
                v-model="defTxtForm.defTxt"
                :label="labels.defTxt"
                v-validate="'required|max:4000'"
                :error-messages="errors.collect('defTxt')"
                data-vv-name="defTxt"
                :data-vv-as="labels.defTxt"
                auto-grow
                :counter="4000"
              ></v-textarea>
            </v-flex>
            <v-flex v-else>
              <v-subheader class="queryLabel">{{ labels.defTxt }}</v-subheader>
              <div class="queryValue">{{ defTxtForm.defTxt }}</div>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-text>
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{ labels.createdName }}</v-subheader>
              <div class="queryValue">{{ defTxtForm.createdName }}</div>
            </v-flex>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
              <div class="queryValue">{{ formatDisplayDate(defTxtForm.createdDate) }}</div>
            </v-flex>
          </v-layout>
          <v-layout row wrap v-if="tranMode !== 'New'">
            <v-flex xs6>
              <v-subheader class="queryLabel">{{ labels.modifiedName }}</v-subheader>
              <div class="queryValue">{{ defTxtForm.modifiedName }}</div>
            </v-flex>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{ labels.modifiedDate }}</v-subheader>
              <div class="queryValue">{{ formatDisplayDate(defTxtForm.modifiedDate) }}</div>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-btn color="error" dark class=" mr-2" @click.prevent="doCancel">Cancel<v-icon dark right>mdi-cancel</v-icon></v-btn>
      <v-btn v-if="tranMode !== 'Query'" color="primary" dark class=" mr-2" @click="doSave" :loading="submitting">
        Save
        <v-icon right>mdi-content-save</v-icon>
      </v-btn>
    </v-card>
  </lazy-div>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
// import { scrRef } from '@/const/params' AR: Commented HARDCODING is not allowed
import { formatDisplayDate } from '@/utils/date'

export default {
  data() {
    return {
      labels: {
        // General
        scrRef: 'Screen Reference',
        txtRef: 'Text Reference',
        txtTitle: 'Text Title',
        defTxt: 'Default Text',
        // Audit
        createdName: 'Created By',
        createdDate: 'Created Date',
        modifiedName: 'Modified By',
        modifiedDate: 'Modified Date'
      },
      defTxtForm: {
        // General
        scrRef: null,
        scrRefDesc: null,
        txtRef: null,
        txtTitle: null,
        defTxt: null,
        // Audit
        createdName: null,
        createdDate: null,
        modifiedName: null,
        modifiedDate: null
      },
      scrRefList: [],
      loading: false,
      defTextPolType: false,
      defTextBusCls: false,
      submitting: false
    }
  },
  computed: {
    defTxtmenu() {
      return this.$store.state.docFormatParam.menu
    },
    newDefTxt() {
      return this.id === 'new'
    },
    polTypeDefTxtValid: () => ['01', '02', '03', '04', '05', '10', '11'],
    busClsDefTxtValid: () => ['20', '21', '22', '30', '31', '32']
  },
  methods: {
    formatDisplayDate(xDate) {
      return formatDisplayDate(xDate)
    },
    async doFetch() {
      await this.scrRefInit()
      if (!this.newDefTxt) {
        const apiUrl = this.defTxtmenu.getDefText
        if (apiUrl) {
          this.loading = true
          try {
            const id = this.id.split('_')
            this.defTxtForm.scrRef = id[0]
            const expand = { scrRef: id[0], txtRef: id[1] }
            const result = await this.$http.get(expandURI(apiUrl, expand))
            const { data } = result.data
            if (data) {
              this.defTxtForm.scrRef = data.scrRef.scrRef
              this.defTxtForm.txtRef = data.scrRef.txtRef
              this.defTxtForm.txtTitle = data.scrRef.txtTitle
              this.defTxtForm.defTxt = data.scrRef.defTxt
              this.defTxtForm.createdName = data.createdBy
              this.defTxtForm.createdDate = data.createdDate
              this.defTxtForm.modifiedName = data.modifiedBy
              this.defTxtForm.modifiedDate = data.modifiedDate
              this.loading = false
            }
          } catch (err) {
            const { data } = err.response
            if (data) {
              this.notify(data)
              this.fieldMessage(data)
            }
          }
        }
      } else {
        this.defTxtForm.createdName = this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName
        this.defTxtForm.createdDate = new Date()
      }
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.newDefTxt) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiUrl = this.defTxtmenu.createDefText
      if (apiUrl) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiUrl, this.defTxtForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.$router.push({ name: 'defTextDet', params: { id: this.defTxtForm.scrRef + '_' + this.defTxtForm.txtRef, tranMode: 'Review' } })
            if (this.polTypeDefTxtValid.includes(this.defTxtForm.scrRef)) {
              this.defTextPolType = true
            }
            if (this.busClsDefTxtValid.includes(this.defTxtForm.scrRef)) {
              this.defTextBusCls = true
            }
          }
          this.submitting = false
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doUpdate() {
      const apiUrl = this.defTxtmenu.updateDefText
      if (apiUrl) {
        this.submitting = true
        try {
          const result = await this.$http.put(apiUrl, this.defTxtForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doFetch()
            this.$router.push({ name: 'defText' })
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.submitting = false
      }
    },
    async scrRefInit() {
      const apiUrl = this.defTxtmenu.getScrRef
      const id = this.id.split('_')
      this.defTxtForm.scrRef = id[0]
      if (apiUrl) {
        try {
          const result = await this.$http.get(apiUrl)
          const { data } = result.data
          this.scrRefList = []
          if (data) {
            data.scrRefList.map((item) => {
              const scrList = {
                value: item.value,
                label: item.value + ' - ' + item.label
              }
              this.scrRefList.push(scrList)
            })
            for (let obj in this.scrRefList) {
              if (Number(this.defTxtForm.scrRef) === Number(this.scrRefList[obj].value)) {
                this.defTxtForm.scrRefDesc = this.scrRefList[obj].label
              }
            }
          }
        } catch (err) {
          const { data } = err.response.data
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doCancel() {
      this.$router.push({ name: 'defText' })
    }
  },
  created() {
    if (!this.newDefTxt) {
      const id = this.id.split('_')
      this.scrRef = id[0]
      this.txtRef = id[1]
      if (this.polTypeDefTxtValid.includes(this.scrRef)) {
        this.defTextPolType = true
      }
      if (this.busClsDefTxtValid.includes(this.scrRef)) {
        this.defTextBusCls = true
      }
    }
  },
  props: ['id', 'tranMode'],
  mixins: [MessageMixin]
}
</script>
